import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
const animationDuration = 150;
const getStateColor = ({ theme, disabled, invalid, readOnly, checked }, state) => {
    const key = state ||
        (disabled && 'disabled') ||
        (checked && 'checked') ||
        (invalid && 'invalid') ||
        (readOnly && 'readOnly') ||
        'default';
    return {
        default: theme.colors.interaction.secondary.default,
        disabled: theme.colors.interaction.secondary.disabled,
        checked: theme.colors.interaction.secondary.active,
        invalid: theme.colors.ui.error,
        readOnly: theme.colors.interaction.secondary.readonly,
    }[key];
};
export const StyledWrapper = styled.div.withConfig({ displayName: "auir-611444a-StyledWrapper", componentId: "auir-611444a-1v4kkr9" }) `
  --inset: var(${(props) => props.theme.responsive.spacing.m});

  position: relative;
  box-sizing: border-box;
  padding: var(--inset);
  outline: var(${getStateColor}) solid 1px;
  background-color: var(${(props) => props.theme.colors.background.level[1]});
  ${injectSpacing('margin')}
  transition: all ${animationDuration}ms ease-in-out;

  ::before {
    content: '';
    pointer-events: none;
    position: absolute;
    inset: -1px;
    border-width: 2px;
    border-color: inherit;
    border-style: solid;
    border-radius: inherit;
    opacity: 0;
    z-index: 2;
    opacity: ${(props) => (props.checked || props.readOnly) && '1'};
    transition: opacity ${animationDuration}ms ease-in-out;
  }

  &:hover {
    outline-color: var(
      ${(props) => !props.disabled &&
    !props.invalid &&
    props.theme.colors.interaction.secondary.hover}
    );
  }
`;
export const StyledLabel = styled.label.withConfig({ displayName: "auir-611444a-StyledLabel", componentId: "auir-611444a-sm8j31" }) `
  display: ${(props) => (props.imgPosition === 'top' ? 'block' : 'flex')};
  gap: var(${(props) => props.theme.responsive.spacing.xs});
  padding: inherit;
  margin: calc(-1 * var(--inset));
  cursor: ${(props) => props.disabled && 'not-allowed'};
  cursor: ${(props) => !(props.disabled || props.readOnly) && 'pointer'};
`;
export const StyledContent = styled.div.withConfig({ displayName: "auir-611444a-StyledContent", componentId: "auir-611444a-hj5wnb" }) `
  display: block;
  flex-grow: 1;
`;
export const StyledImgWrapper = styled.div.withConfig({ displayName: "auir-611444a-StyledImgWrapper", componentId: "auir-611444a-a4gxpy" }) `
  position: relative;
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: ${(props) => (props.placement === 'top' ? '100%' : '30%')};
  max-width: ${(props) => props.placement === 'aside' && '120px'};
  margin-inline: ${(props) => props.placement === 'top' && 'calc(-1 * var(--inset))'};
  margin-block-start: ${(props) => props.placement === 'top' && 'calc(-1 * var(--inset))'};
  margin-block-end: ${(props) => props.placement === 'top' && 'var(--inset)'};
  order: ${(props) => props.placement === 'aside' && '2'};
  overflow: hidden;

  img {
    object-fit: ${(props) => (props.placement === 'top' ? 'cover' : 'contain')};
    object-position: top right;
    width: 100%;
    aspect-ratio: ${(props) => (props.placement === 'top' ? '16/9' : 'auto')};
  }
`;
export const StyledPrice = styled.p.withConfig({ displayName: "auir-611444a-StyledPrice", componentId: "auir-611444a-acmhkr" }) `
  font-family: var(${(props) => props.theme.fontFamily});
  color: var(${(props) => props.theme.colors.ui.secondary}) !important;
  font-size: var(
    ${(props) => props.theme.responsive.typography.copy2.fontSize}
  );
  margin: var(${(props) => props.theme.responsive.spacing.s}) 0;
`;
export const StyledToolbar = styled.div.withConfig({ displayName: "auir-611444a-StyledToolbar", componentId: "auir-611444a-a63ea6" }) `
  margin-block-start: var(--inset);
`;
export const StyledControlWrapper = styled.div.withConfig({ displayName: "auir-611444a-StyledControlWrapper", componentId: "auir-611444a-ym5x92" }) `
  margin-bottom: var(${(props) => props.theme.responsive.spacing.s});
`;
//# sourceMappingURL=ExtendedSelection.styles.mjs.mjs.map